export default __webpack_public_path__ + "static/media/happy-birthday2.82ae716e.webp";